import React, { Component } from 'react';

export default class EmptyData extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <img style={{ width: 200 }} src="/EmptyInbox.png" />
        <h4 style={{ color: 'black',marginTop:'-33px' }}>{this.props.type ==='singleResource'?'No Risk found':'No Resource found'}</h4>
        {this.props.type ==='resourceFinder' && <p>{this.props.emptyFilterText}</p>}
      </div>
    );
  }
}
